// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YDmq","title":"styles_title__2W-2E"};